import { MutationHookOptions, useMutation } from "@apollo/react-hooks";

import updateInsurance from "../graph-ql/updateInsurance.graphql";

const useMutationUpdateInsurance = (opts?: MutationHookOptions) =>
  useMutation<{ updateInsurance: { id: string } }>(updateInsurance, opts);

export default useMutationUpdateInsurance;
